import React from "react";

export type IZendeskContext = boolean; // whether hide or not

const ZendeskContext = React.createContext<IZendeskContext>(false); // visible by default

export default ZendeskContext;
